import React, { useState } from "react";
import { Star, Quote, ChevronLeft, ChevronRight } from "lucide-react";

const ServiceTestimonials = () => {
  const [currentTestimonial, setCurrentTestimonial] = useState(0);

  const testimonials = [
    {
      id: 1,
      name: "Priya Sharma",
      role: "Bride",
      location: "Banglore",
      rating: 5,
      text: "Aastha transformed me into the most beautiful bride I could have imagined. Her attention to detail and understanding of my vision was incredible. I felt confident and radiant all day!",
      service: "Complete Bridal Package",
      image: "/api/placeholder/80/80",
    },
    {
      id: 2,
      name: "Riya Patel",
      role: "Party Client",
      location: "Delhi",
      rating: 5,
      text: "The party makeup was absolutely stunning! Everyone kept asking who did my makeup. Aastha is truly an artist and made me feel like a princess for my birthday celebration.",
      service: "Party Makeup",
      image: "/api/placeholder/80/80",
    },
    {
      id: 3,
      name: "Ananya Singh",
      role: "Fashion Model",
      location: "Lucknow",
      rating: 5,
      text: "Working with Aastha for my editorial shoot was amazing. Her creativity and technical skills are unmatched. The makeup looked flawless in every photo and lasted all day.",
      service: "Editorial Makeup",
      image: "/api/placeholder/80/80",
    },
    {
      id: 4,
      name: "Sneha Reddy",
      role: "Training Student",
      location: "Hyderabad",
      rating: 5,
      text: "The makeup training course exceeded my expectations. Aastha is an excellent teacher who explains everything clearly. I learned so much and now feel confident doing professional makeup.",
      service: "Makeup Training",
      image: "/api/placeholder/80/80",
    },
    {
      id: 5,
      name: "Kavya Joshi",
      role: "Bride",
      location: "Lucknow",
      rating: 5,
      text: "From the trial to the wedding day, everything was perfect. Aastha understood exactly what I wanted and delivered beyond my expectations. Highly recommended!",
      service: "Complete Bridal Package",
      image: "/api/placeholder/80/80",
    },
  ];

  const nextTestimonial = () => {
    setCurrentTestimonial((prev) => (prev + 1) % testimonials.length);
  };

  const prevTestimonial = () => {
    setCurrentTestimonial(
      (prev) => (prev - 1 + testimonials.length) % testimonials.length
    );
  };

  const current = testimonials[currentTestimonial];

  return (
    <section className="py-16 md:py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-display text-black mb-4">
            Client Testimonials
          </h2>
          <p className="text-lg text-[#622935] max-w-2xl mx-auto font-body">
            Hear from our satisfied clients about their experience with AWM
            Makeovers. Their stories inspire us to keep creating beautiful
            transformations.
          </p>
        </div>

        {/* Testimonial Carousel */}
        <div className="relative max-w-4xl mx-auto">
          {/* Main Testimonial Card */}
          <div className="bg-beige-light rounded-2xl p-8 md:p-12 shadow-lg">
            {/* Quote Icon */}
            <div className="flex justify-center mb-6">
              <div className="w-16 h-16 bg-wine/10 rounded-full flex items-center justify-center">
                <Quote className="w-8 h-8 text-wine" />
              </div>
            </div>

            {/* Testimonial Content */}
            <div className="text-center mb-8">
              <p className="text-lg md:text-xl text-black font-body italic mb-6 leading-relaxed">
                "{current.text}"
              </p>

              {/* Rating */}
              <div className="flex justify-center mb-4">
                {[...Array(5)].map((_, i) => (
                  <Star
                    key={i}
                    className="w-5 h-5 text-yellow-400"
                    fill="currentColor"
                  />
                ))}
              </div>

              {/* Client Info */}
              <div className="flex items-center justify-center space-x-4">
                <div className="w-16 h-16 bg-wine/20 rounded-full flex items-center justify-center">
                  <span className="text-2xl font-display text-wine">
                    {current.name.charAt(0)}
                  </span>
                </div>
                <div className="text-left">
                  <h4 className="text-xl font-display text-black">
                    {current.name}
                  </h4>
                  <p className="text-wine-light font-body">
                    {current.role} • {current.location}
                  </p>
                  <p className="text-sm text-wine font-body font-medium">
                    {current.service}
                  </p>
                </div>
              </div>
            </div>
          </div>

          {/* Navigation Controls */}
          <div className="flex justify-center items-center space-x-4 mt-8">
            <button
              onClick={prevTestimonial}
              className="w-12 h-12 bg-wine text-white rounded-full flex items-center justify-center hover:bg-wine-dark transition-colors duration-300"
            >
              <ChevronLeft className="w-6 h-6" />
            </button>

            {/* Dots Indicator */}
            <div className="flex space-x-2">
              {testimonials.map((_, index) => (
                <button
                  key={index}
                  onClick={() => setCurrentTestimonial(index)}
                  className={`w-3 h-3 rounded-full transition-colors duration-300 ${
                    index === currentTestimonial ? "bg-wine" : "bg-wine/30"
                  }`}
                />
              ))}
            </div>

            <button
              onClick={nextTestimonial}
              className="w-12 h-12 bg-wine text-white rounded-full flex items-center justify-center hover:bg-wine-dark transition-colors duration-300"
            >
              <ChevronRight className="w-6 h-6" />
            </button>
          </div>
        </div>

        <div className="text-center mt-16">
          <div className="bg-gradient-to-r from-wine to-wine-dark rounded-2xl p-8 text-white">
            <h3 className="text-2xl md:text-3xl font-display mb-4">
              Ready to Join Our Happy Clients?
            </h3>
            <p className="text-lg mb-6 opacity-90 font-body">
              Book your consultation today and experience the AWM Makeovers
              difference.
            </p>
            <a
              href="https://wa.me/message/MV27FW4PH7CGH1"
              target="_blank"
              rel="noopener noreferrer"
            >
              <button className="bg-white text-wine px-8 py-4 rounded-lg font-medium hover:bg-beige transition-colors duration-300 font-body">
                Book Your Session
              </button>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ServiceTestimonials;
